(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/shared/hooks/use-wagers-hook.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/shared/hooks/use-wagers-hook.js');
'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const logger = svs.arena.logger;
const {
  useState,
  useCallback
} = React;
const {
  fetchTeamWagers
} = svs.arena.store.wagers.actions;

const useWagers = teamId => {
  const dispatch = ReactRedux.useDispatch();
  const [statusState, setStatusState] = useState({
    isSuccess: false,
    isLoading: false
  });

  const wagerData = ReactRedux.useSelector(state => state.wagers[teamId]) || {};
  const loadingError = false;
  const fetchData = useCallback(async () => {
    logger.debug('useWagersHook: fething new data (wagers) from server');
    setStatusState(prevState => _objectSpread(_objectSpread({}, prevState), {}, {
      isLoading: true
    }));
    const fetchData = await dispatch(fetchTeamWagers(teamId));
    setStatusState({
      isSuccess: RTK.isFulfilled(fetchData),
      isLoading: false
    });
  }, [dispatch, teamId]);
  React.useEffect(() => {
    const timeOut = Math.floor(Math.random() * 50);
    setTimeout(() => {
      logger.debug("Get initial wagers for teamId ".concat(teamId, " delayed for ").concat(timeOut, " ms"));
      fetchData();
    }, timeOut);
  }, []);
  return {
    wagerData,
    isLoading: statusState.isLoading,
    isSuccess: statusState.isSuccess,
    error: loadingError
  };
};
svs.arena.shared.hooks.useWagers = useWagers;

 })(window);